export default function sanitizeString(value: string): string {
    const timestamp = new Date().getTime(); // Current timestamp
    const extension = value.slice(value.lastIndexOf('.')); // includes the dot
    const baseName = value.slice(0, value.lastIndexOf('.')).replace(/[^a-zA-Z0-9-_]/g, '_');
    return `${baseName}_${timestamp}${extension}`;
}
